import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=72612893&"
import script from "./ColorPicker.vue?vue&type=script&lang=ts&"
export * from "./ColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VColorPicker,VMenu,VSheet})
